/**
 * Divider
 *
 * @author edmsamuel
 */
import React from 'react';

function Divider(props) {
  return (
    <div
      className={`divider ${props.mode || 'vertical'}`}
      style={{ height: 1, marginTop: props.margin || 7, marginBottom: props.margin || 7 }}
    />
  )
}

export default Divider
